// Options for the admission enquiry form (/admission).
const admission = {
  title: "Admission Enquiry",
  subtitle:
    "Tell us about the patient and our team will call you back to guide you through admission.",
  relations: [
    "Self",
    "Parent",
    "Spouse",
    "Son / Daughter",
    "Brother / Sister",
    "Other relative",
    "Friend",
  ],
  problems: [
    "Drug addiction",
    "Alcohol dependence",
    "Depression / anxiety",
    "Psychosis / schizophrenia",
    "Bipolar disorder",
    "Child / adolescent problem",
    "Other / not sure",
  ],
  urgency: [
    { value: "urgent", label: "Urgent — within 24 hours" },
    { value: "week", label: "Within this week" },
    { value: "info", label: "Just collecting information" },
  ],
  steps: [
    {
      icon: "icon-phone",
      title: "1. Send the form",
      desc: "Tell us about the patient. It takes 2 minutes.",
    },
    {
      icon: "icon-call3",
      title: "2. We call you",
      desc: "Our team calls you back to understand the situation.",
    },
    {
      icon: "icon-doctor",
      title: "3. Assessment",
      desc: "A psychiatrist assesses the patient and recommends care.",
    },
    {
      icon: "icon-hospital",
      title: "4. Admission",
      desc: "If needed, the patient is admitted with a clear plan.",
    },
  ],
  bring: [
    "Previous prescriptions and test reports",
    "National ID / birth certificate of patient and guardian",
    "Personal clothes and toiletries",
    "Advance payment for the chosen package",
  ],
  formTitle: "Patient & Guardian Details",
  formDesc: "All information is kept strictly confidential.",
  bringTitle: "What to bring at admission",
};

export default admission;
